import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="mb-12 text-center" data-id="element-109">
      <p className="text-sm md:text-base font-bold tracking-widest text-[#1B2A4A] uppercase mb-6 opacity-80" data-id="element-110">
        FOR MEN 62+ WHO CLAIMED EARLY
      </p>

      <h1 className="text-3xl md:text-5xl lg:text-[3.5rem] font-bold leading-[1.2] text-[#1B2A4A] mb-8 max-w-4xl mx-auto" data-id="element-111">
        The Social Security &quot;Do-Over&quot;: How to Erase an Early-Claim
        Mistake and Boost Your Check by 32%
      </h1>

      <div className="h-1 w-24 bg-[#D4652A] mx-auto rounded-full mb-10" data-id="element-112" />

      {/* Product image */}
      <div className="flex justify-center" data-id="element-113">
        <div className="relative max-w-[360px] w-full" data-id="element-114">
          <div className="absolute inset-0 bg-[#1B2A4A]/5 blur-xl transform scale-95 translate-y-4 rounded-full" data-id="element-115" />
          <img src="https://cdn.magicpatterns.com/uploads/cRsVbm8sHqGiXe7jkfd9yR/heylloyd-image-1771298404236.png" alt="Social Security Claiming Mistake Rescue Guide on Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-116" />
        </div>
      </div>
    </motion.section>;
}